import { Box, Button, Card, CardContent, Grid, Typography, Avatar, List, ListItem } from "@mui/material";
import QRCode from "react-qr-code";
import { ReactComponent as BlockchainBtnImg } from "../../assets/BlockchainBtnImg.svg";
import { ReactComponent as BlockchainBtnHover } from "../../assets/BlockchainBtnHover.svg";
import { ReactComponent as Blockchainicon } from "../../assets/blockchainicon.svg";
import { ReactComponent as Joker } from "../../assets/dashboardIcons/JokerIcon.svg"
import { Navigate, useNavigate } from "react-router-dom";

export default function Scanner({ open, setOpen, setActiveStep, activeStep }) {
  return (
    <Box className='scannerBlock'>
      <h3 className="sectiontitleSmall">Tracciabilità</h3>
      <Card sx={{ display: "flex", maxWidth: 800, width: "100%", boxShadow: 3, borderRadius: 2 }}>
        {/* Left Side: QR Code & Button */}
        <Box className='scannerBlock__scannerBox'>
          <Box className='scanner'>
            <QRCode value="https://blockchain.example.com/trace" size={128} />
          </Box>
          {/* <Button onClick={() => { setOpen(!open), setActiveStep(activeStep + 1) }} variant="outlined" sx={{ mt: 2, color: "blue", borderColor: "blue" }}>
            Invia dati in blockchain
          </Button> */}
          <Button
            className={"btn blockchainBtn"
            }
            onClick={() => { setOpen(!open)}}
            type="button"
          > 
            <p className="text">

              <BlockchainBtnImg />
              <>
                <span className="defaultText">
                  Invia dati in blockchain
                </span>
              </>

            </p>


            <BlockchainBtnHover className="hoverImg" />


          </Button>
        </Box>

        {/* Middle Content: Information */}
        <CardContent  >
         
          <List className="listGroup">
            <ListItem>
              <Typography variant="body2" >
              Validato da vivon
            </Typography>
            </ListItem>
            <ListItem>
            <Typography sx={{color:"#4799D5 !important"}} variant="body2" >|</Typography>
            </ListItem>
            <ListItem>
            <Typography variant="body2" >Registrato il -</Typography>
            </ListItem>
            <ListItem>
            <Typography variant="body2" >Blockchain -</Typography>
            </ListItem>
            <ListItem>
            <Typography variant="body2" >Fasi registrate</Typography>
            </ListItem>
          </List>
          <Box className='jokarImage' >
            <Joker />
          </Box>

        </CardContent>

        {/* Right Side: Mascot Image */}

      </Card>
    </Box>
  );
}
